<template>
  <v-autocomplete
    color="primary"
    hide-no-data
    v-model="recipesSelected"
    :clearable="!unclearable"
    :items="recipesItems"
    :loading="recipesLoading"
    :search-input.sync="recipesSearch"
    item-text="Description"
    item-value="id"
    item-disabled="disabled"
    :label="noLabel ? '' : $t('Recipes.ObjectName')"
    return-object
    :single-line="dense"
    :dense="dense"
    :hide-details="dense"
    :style="dense ? 'margin-left: auto; margin-right: auto' : ''"
    :error-messages="errorMessages"
  ></v-autocomplete>
</template>

<script>
import Recipes from "@/api/recipes";

export default {
  name: "SearcherRecipe",

  props: {
    value: Object,
    districtID: Number,
    allianceBusinessIds: Array,
    noLabel: Boolean,
    dense: Boolean,
    unclearable: Boolean,
    disabledItems: Array,
    errorMessages: Array,
    isActivity: Boolean,
  },

  computed: {
    recipesItems() {
      return this.recipes.map((recipe) => {
        const Description = recipe.formula_code + " / " + recipe.formula_name;
        const disabled = this.disabledItems
          ? this.disabledItems.find(
              (disabledItem) => disabledItem.id == recipe.id
            )
          : false;
        return Object.assign({}, recipe, { Description, disabled });
      });
    },
  },

  data: () => ({
    recipes: [],
    recipesLoading: false,
    recipesSearch: "",
    recipesSelected: null,
  }),

  mounted() {
    this.getRecipesFromAPI();
  },

  methods: {
    getRecipesFromAPI() {
      this.recipesLoading = true;
      var options = {
        district_id: this.districtID,
        alliance_business_ids: this.allianceBusinessIds,
      };
      if (this.isActivity) {
        options.status = [1];
      }
      Recipes.fetchAllForSelect(options)
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.recipes = response.data.food_formula;
            }
            this.recipesLoading = false;
          }.bind(this)
        )
        .catch(
          function () {
            this.recipesLoading = false;
          }.bind(this)
        );
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.recipesSelected = this.value;
      },
    },
    recipesSelected: {
      handler() {
        this.$emit("input", this.recipesSelected);
      },
    },
    districtID: {
      handler() {
        this.getRecipesFromAPI();
      },
    },
    allianceBusinessIds: {
      handler() {
        this.getRecipesFromAPI();
      },
    },
  },
};
</script>
